<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <v-row>
              <h1 class="headline">
                {{ $t('appealInfo.title') }} #{{ appealId }}
              </h1>
              <v-flex xs12 sm6 md6 lg6>
                  <v-layout wrap align-center justify-end>
                      <v-btn
                        type="button"
                        class="d-flex align-right"
                        color="green lighten-1"
                        large
                        depressed
                        @click="goBack"
                      >
                         {{ $t('common.btns.back') }}
                      </v-btn>
                  </v-layout>
              </v-flex>
          </v-row>
        </v-flex>
      </v-layout>
      <appeal-form :appealId="appealId" />
    </v-flex>
  </v-layout>
</template>

<script>
import AppealForm from '@/components/appeals/AppealForm.vue';

export default {
  name: 'AppealInfoPage',
  components: {
    AppealForm,
  },
  data() {
    return {
      appealId: null,
    };
  },
  created() {
    const { appealId } = this.$route.params;
    this.appealId = appealId;
  },
  computed: {
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="scss" scoped></style>
